import { c as _c } from "react/compiler-runtime";
import { mutate } from 'swr';
import useMutation from 'use-mutation';
import { usePolicyApi } from '../api/policy-api';
import { routes } from '../bff/routes';
import type { GetPolicyByUuidResponse, UpdatePolicyLinesOfCoverageBody, UpdatePolicyLinesOfCoverageParams, UpdatePolicyLinesOfCoverageResponse } from '../bff/types';
import { useGetApiCacheKey } from '../utils/hooks/useGetApiCacheKey';

// TODO: should be removed once use-mutation lib types are fixed
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function useUpdatePolicyLocs() {
  const $ = _c(4);
  const policyApi = usePolicyApi();
  const getCacheKey = useGetApiCacheKey();
  let t0;
  if ($[0] !== policyApi) {
    t0 = t1 => {
      const {
        params,
        body
      } = t1;
      return policyApi.updateLinesOfCoverage(params, body);
    };
    $[0] = policyApi;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== getCacheKey) {
    t1 = {
      onSuccess(t2) {
        const {
          input,
          data
        } = t2;
        return mutate(getCacheKey(routes.policyByUuid.getUrl(input.params)), current => {
          if (data) {
            return data;
          }
          return current;
        });
      },
      throwOnFailure: true
    };
    $[2] = getCacheKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useMutation(t0, t1);
}